module.exports = __webpack_public_path__ + "img/question-circle.d6cc9195.svg";